import { getCurrentCompositeConfiguration } from '../helpers/compositeProducts';
import { asyncCallRoutePost, asyncCallRouteGet } from '../helpers/api';

export class AddOrderItemPage {
	constructor( element ) {
		this.summeryInnerWrapper = element.querySelector( '.summary-inner-wrapper' );
		this.cartForm = element.querySelector( 'form.cart' );

		this.createOrderItemButton = null;
		this.orderField = null;
		this.orderFieldSelect = null;
		this.notice = null;

		const productElement = element.querySelector( '.product' );
		this.productType = this.getProductType( productElement );
		this.productId = this.getProductId( productElement );

		this.addToOrderText = window.QalaB2bWholesale.text.addToOrder;
		this.addingToOrderText = window.QalaB2bWholesale.text.addingToOrder;
		this.addText = window.QalaB2bWholesale.text.add;
		this.selectOrderText = window.QalaB2bWholesale.text.selectOrder;
		this.viewOrderUrl = window.QalaB2bWholesale.viewOrderUrl;

		this.routeUrl = window.QalaB2bWholesale.updateOrderRouteObj.routeUrl;
		this._wpnonce = window.QalaB2bWholesale.updateOrderRouteObj._wpnonce;

		this.routeUrlListOrder = window.QalaB2bWholesale.listOrderRouteObj.routeUrl;
	}

	/**
	 * Initialize the class
	 */
	init() {
		if ( ! this.isOrderEditingAllowed() ) {
			return;
		}

		this.setupCreateAddToOrderButton();
		this.setupAddToOrderField();
		this.setupAddToOrderNotice();
	}

	/**
	 * Returns whether order editing is enabled or not.
	 *
	 * @return {boolean} isEditable
	 */
	isOrderEditingAllowed = () => {
		const isEditable = QalaB2bWholesale?.isOrdersEditable ?? false;
		return ( isEditable === '1' || isEditable === 1 ) ? true : false;
	};

	/**
	 * Get the product id from the product element
	 *
	 * @param {HTMLElement} productElement
	 *
	 * @return {number} Product id
	 */
	getProductId( productElement ) {
		return +productElement.id.replace( 'product-', '' );
	}

	/**
	 * Get the product type from the product element
	 *
	 * @param {HTMLElement} productElement
	 *
	 * @return {string} Product type
	 */
	getProductType( productElement ) {
		let productType = null;

		productElement.classList.forEach( className => {
			if ( className.startsWith( 'product-type-' ) ) {
				productType = className.replace( 'product-type-', '' );
			}
		} );

		return productType;
	}

	/**
	 * Setup the create add to order button
	 *
	 * @return {void}
	 */
	setupCreateAddToOrderButton() {
		this.createOrderItemButton = this.createAddToOrderButton();
		this.cartForm.appendChild( this.createOrderItemButton );
	}

	/**
	 * Setup the add to order field
	 *
	 * @return {void}
	 */
	setupAddToOrderField() {
		this.orderField = this.createOrderField();
		this.cartForm.appendChild( this.orderField );
		this.fillOrderField();
		this.setupSelect2( this.orderFieldSelect );
	}

	/**
	 * Setup the add to order notice
	 *
	 * @return {void}
	 */
	setupAddToOrderNotice() {
		this.notice = this.createNotice();
		this.cartForm.appendChild( this.notice );
	}

	/**
	 * Setup the select2
	 *
	 * We are using selectWoo here which is WooCommerce wrapper for select2.
	 *
	 * @param {HTMLSelectElement} orderFieldSelect
	 */
	setupSelect2( orderFieldSelect ) {
		const orderFieldSubmit = this.orderField.querySelector( '.add-order-item-button' );

		jQuery( orderFieldSelect ).selectWoo( {
			width: '100%',
		} ).on( 'change', function( e ) {
			orderFieldSubmit.disabled = ! e.target.value;
		} );
	}

	/**
	 * Create the add to order button
	 *
	 * @return {HTMLButtonElement} Button
	 */
	createAddToOrderButton() {
		const button = document.createElement( 'button' );

		button.type = 'button';
		button.classList.add( 'add-order-item-button', 'btn' );
		button.innerHTML = this.addToOrderText;
		button.addEventListener( 'click', this.showAddOrderItem.bind( this ) );

		return button;
	}

	/**
	 * Create the add to order field
	 *
	 * @return {HTMLDivElement} Field
	 */
	createOrderField() {
		const container = document.createElement( 'div' );
		container.classList.add( 'add-order-item' );

		const field = document.createElement( 'div' );
		field.classList.add( 'add-order-item-field' );

		this.orderFieldSelect = document.createElement( 'select' );
		this.orderFieldSelect.classList.add( 'add-order-item-select' );
		const option = document.createElement( 'option' );
		option.value = '';
		option.innerHTML = this.selectOrderText;
		this.orderFieldSelect.appendChild( option );

		const buttonContainer = document.createElement( 'div' );
		buttonContainer.classList.add( 'add-order-item-submit' );

		const button = document.createElement( 'button' );
		button.type = 'button';
		button.disabled = true;
		button.classList.add( 'add-order-item-button', 'btn' );
		button.innerHTML = this.addText;
		button.addEventListener( 'click', this.addOrderItem.bind( this ) );
		buttonContainer.appendChild( button );

		field.appendChild( this.orderFieldSelect );

		container.appendChild( field );
		container.appendChild( buttonContainer );

		return container;
	}

	/**
	 * Create the add to order notice
	 *
	 * @return {HTMLDivElement} Notice
	 */
	createNotice() {
		const notice = document.createElement( 'div' );
		notice.classList.add( 'add-order-item-notice' );
		return notice;
	}

	/**
	 * Show a notice
	 *
	 * @param {string} message Notice message.
	 * @param {string} type    Notice type.
	 *
	 * @return {void}
	 */
	showNotice( message, type = 'error' ) {
		this.notice.innerHTML = message;

		if ( type === 'success' ) {
			this.notice.classList.remove( 'woocommerce-error' );
			this.notice.classList.add( 'woocommerce-message' );
		}

		if ( type === 'error' ) {
			this.notice.classList.remove( 'woocommerce-message' );
			this.notice.classList.add( 'woocommerce-error' );
		}
	}

	/**
	 * Show the add to order field
	 *
	 * @return {void}
	 */
	showAddOrderItem() {
		this.orderField.style.display = 'flex';
	}

	/**
	 * Set the add to order item button loading
	 *
	 * @param {boolean} enabled
	 */
	setAddOrderItemLoading( enabled ) {
		const addOrderItemButton = this.orderField.querySelector( '.add-order-item-button' );

		if ( enabled ) {
			addOrderItemButton.disabled = true;
			addOrderItemButton.innerHTML = this.addingToOrderText;
		} else {
			addOrderItemButton.disabled = false;
			addOrderItemButton.innerHTML = this.addText;
		}
	}

	/**
	 * Add the order item
	 *
	 * @return {Promise<void>}
	 */
	async addOrderItem() {
		this.setAddOrderItemLoading( true );
		const orderId = +this.orderFieldSelect.value;
		let fields = {};

		if ( this.productType === 'variable' ) {
			fields.variation_id = +this.summeryInnerWrapper.querySelector( 'input[name="variation_id"]' ).value;
		}

		if ( this.productType === 'composite' ) {
			fields = [];
			const compositeComponents = this.summeryInnerWrapper.querySelectorAll( '.composite_component' );

			compositeComponents.forEach( component => {
				const componentId = +component.dataset.item_id;
				const componentConfig = window.wc_cp_composite_scripts[ this.productId ].api.get_component_configuration( componentId );

				fields.push( {
					component_id: componentId,
					title: componentConfig.title,
					product_id: +componentConfig.product_id,
					variation_id: +componentConfig.variation_id,
					attributes: componentConfig.selection_meta,
				} );
			} );
		}

		try {
			const compositeConfiguration = getCurrentCompositeConfiguration();
			const response = await asyncCallRoutePost( this.routeUrl, this._wpnonce, {
				order_id: orderId,
				items_to_add: [
					{
						product_id: this.productId,
						product_type: this.productType,
						fields,
						composite_configuration: compositeConfiguration ? JSON.stringify( compositeConfiguration ) : null,
					},
				],
			} );

			if ( response?.data?.status && response.data.status === 200 ) {
				this.showNotice( response.message, 'success' );
				this.createOrderItemButton.remove();
				this.orderField.remove();
				window.location.href = this.viewOrderUrl + orderId;
			} else {
				this.showNotice( response.message, 'error' );
			}
		} catch ( e ) {}

		this.setAddOrderItemLoading( false );
	}

	/**
	 * Fill the order field with data from the server.
	 *
	 * @return {Promise<void>}
	 */
	async fillOrderField() {
		try {
			const responseData = await asyncCallRouteGet( this.routeUrlListOrder, this._wpnonce );

			if ( responseData && responseData?.data && responseData?.data?.orders ) {
				responseData.data.orders.forEach( order => {
					const option = document.createElement( 'option' );
					option.value = order.id;
					option.innerHTML = order.title;
					this.orderFieldSelect.appendChild( option );
				} );
			}
		} catch ( e ) {}
	}
}
